// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { __ } from '../../../../i18n/l10n';
import type { BetslipDisplayStatus } from '../../../../types/betslip';
import CurrencyExposant from '../CurrencyExposant';

import GridStatus from './GridStatus';

const Flex = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  margin: ${Target.__MOBILE__ ? '1em' : '1em 0'};
`;

const commonBloc = css`
  width: 100%;
  text-align: center;
  border-radius: 0.4em;
  padding: 0.6em;
  margin: 0 0.2em;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledStatus = styled(GridStatus)`
  ${commonBloc}
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

const Bloc = styled.div`
  ${commonBloc}
  border: solid 2px ${({ theme }) => theme.grids.colors.darkgrey4};
  background: ${({ theme }) => theme.grids.colors.black};
`;

const BetAmount = styled(CurrencyExposant)`
  display: block;
  color: #fff;
  line-height: 1;
  margin: 0;
`;

const Winnings = styled(CurrencyExposant)`
  color: ${({ theme }) => theme.grids.colors.greenwin};
  font-size: 1.1em;
`;

const P = styled.p`
  margin: 0.2em 0;
  text-transform: uppercase;
  font-family: BettingPoliticaBold, sans-serif;
  font-size: 0.9em;
  line-height: 1;
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
`;

type GridsHistoryGridHeaderStatusProps = {
  className?: string;
  betAmount: number;
  winningsAmount?: number;
  status: BetslipDisplayStatus;
  statusLabel: string;
  gridAmount: number;
  isShare?: boolean;
};

const GridsHistoryGridHeaderStatus = ({
  className,
  betAmount,
  winningsAmount,
  status,
  statusLabel,
  gridAmount,
  isShare = false,
}: GridsHistoryGridHeaderStatusProps) => {
  return (
    <Flex className={className}>
      <StyledStatus status={status} statusLabel={statusLabel} />
      <Bloc>
        {betAmount !== 0 ? (
          <div>
            <P>{isShare ? __('Wager') : __('My wager')}</P>
            <BetAmount amount={betAmount} />
          </div>
        ) : (
          <div>
            <P>{__('Grid price')}</P>
            <BetAmount amount={gridAmount} />
          </div>
        )}
      </Bloc>
      {winningsAmount ? (
        <Bloc>
          <div>
            <P>{isShare ? __('Total winnings') : __('My winnings')}</P>
            <Winnings amount={winningsAmount} />
          </div>
        </Bloc>
      ) : null}
    </Flex>
  );
};

export default GridsHistoryGridHeaderStatus;
